import { EmptyArray } from "../domain/empty/model";
import { TaxesRepositoryImplementation } from '../infrastructure/taxes-repository-implementation';


import { cacheManager } from '../infrastructure/cache-manager';

const repo = new TaxesRepositoryImplementation();
const CACHE_PREFIX = 'taxes';

async function getTaxes(page: number, limit: number) {
    const cacheKey = `${CACHE_PREFIX}-list-${page}-${limit}`;
    const cached = cacheManager.getItem(cacheKey);

    if (cached) {
        return cached;
    }

    const result = await repo.get(page, limit).toPromise();
    if (!result || !result.data || !result.data.data || result.data.data.length === 0) {
        return { data: { data: EmptyArray, total: 0, page: page, page_size: limit } };
    }

    cacheManager.setItem(cacheKey, result);
    return result;
}

async function createTax(body: any) {
    const result = await repo.create(body).toPromise();
    if (!result) throw new Error("No response from tax creation");
    cacheManager.invalidate(CACHE_PREFIX);
    return result.data;
}

async function getTaxById(id: number) {
    const cacheKey = `${CACHE_PREFIX}-detail-${id}`;
    const cached = cacheManager.getItem(cacheKey);

    if (cached) {
        console.log(`Returning tax with id ${id} from cache`);
        return cached;
    }

    const result = await repo.getById(id).toPromise();
    if (!result || !result.data) return EmptyArray;
    const data = result.data;
    cacheManager.setItem(cacheKey, data);
    return data;
}

async function updateTax(id: number, body: any) {
    const result = await repo.update(id, body).toPromise();
    if (!result) throw new Error("No response from tax update");
    cacheManager.invalidate(CACHE_PREFIX);
    return result.data;
}

async function deleteTax(id: number) {
    const result = await repo.delete(id).toPromise();
    if (!result) throw new Error("No response from tax deletion");
    cacheManager.invalidate(CACHE_PREFIX);
    return result.data;
}

export { getTaxes, createTax, getTaxById, updateTax, deleteTax };
